import { render, staticRenderFns } from "./addStageControl.vue?vue&type=template&id=20bf6ea8&scoped=true"
import script from "./addStageControl.vue?vue&type=script&lang=js"
export * from "./addStageControl.vue?vue&type=script&lang=js"
import style0 from "./addStageControl.vue?vue&type=style&index=0&id=20bf6ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf6ea8",
  null
  
)

export default component.exports